import {CallerType} from '../../copilot.enums';
import {Caller} from '../../copilot.types';
import appendToCallChain from './appendToCallChain';

export default function appendCustomCallerToCallChain(name: string, callChain: Caller[]): Caller[] {
  return appendToCallChain({name, type: CallerType.Custom}, callChain);
}
